import { IconClipboardCheck } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import docs from '../documents/Documents.module.css';
import { revisionText } from '../documents/library.js';
import { RecordBadges } from './FormRecordParts.js';
import classes from './Forms.module.css';
import { recordStatusBadges } from './status.js';
import type { FormRecordDetail } from './types.js';

/**
 * Kayıt sayfasının başlık kartı (gemi-ism-formlari.jpeg başlık kartının dili; ADR 0042 §21):
 * mavi karoda ikon, kayıt no ve form no ile adı, altında bağlı revizyon ve gemi; durum, Amended
 * ve işaret rozetleri; sağda başlık eylemleri (kapak sayfası). Başlıktaki "Edit" belgenin
 * revizyonudur; kayıt değişikliği "Amend"dir (§21).
 */
export function FormRecordHeader({
  record,
  actions,
}: {
  record: FormRecordDetail;
  actions?: ReactNode;
}) {
  const { t } = useTranslation();
  const form = `${t('forms.record.formNo', { no: record.docNo })} - ${record.documentTitle}`;
  const subtitle = [
    form,
    revisionText(record.revisionNo),
    record.vessel?.name ?? null,
    record.title,
  ]
    .filter(Boolean)
    .join(' · ');
  return (
    <section className={`${docs.head} ${classes.recordHead}`} aria-label={record.recordNo}>
      <span className={docs.headIcon} aria-hidden>
        <IconClipboardCheck size={30} stroke={1.5} />
      </span>
      <div className={docs.headText}>
        <h2 className={docs.headTitle} title={record.recordNo}>
          {t('forms.record.heading', { record: record.recordNo })}
        </h2>
        <p className={docs.headPath} title={subtitle}>
          {subtitle}
        </p>
        <RecordBadges badges={recordStatusBadges(t, record.status, record.flags)} />
      </div>
      {actions ? (
        <div className={`${docs.headActions} ${classes.recordHeadActions}`}>{actions}</div>
      ) : null}
    </section>
  );
}
